import {AUTHHTTP} from "@/http";
import {saveToken, removeToken} from "@/helper/LocalStorageHelper";
import router from "../router"


export default class AuthService {

  clientId = process.env.VUE_APP_CLIENT_ID;
  clientSecret = process.env.VUE_APP_CLIENT_SECRET;

  constructor() {
  }

  identify(username) {
    return AUTHHTTP.post('api/v2/auth/identify', {username})
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  }

  doLogin(username, password) {
    let data = new URLSearchParams();

    data.append('grant_type', 'password');
    data.append('password', password);
    data.append('username', username);
    data.append('client_id', this.clientId);
    data.append('client_secret', this.clientSecret);

    return AUTHHTTP.post('api/v2/auth/login', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  }

  doEntraLogin(accessToken) {
    let data = new URLSearchParams();

    data.append('grant_type', 'entra_token');
    data.append('access_token', accessToken);
    data.append('client_id', this.clientId);
    data.append('client_secret', this.clientSecret);

    return AUTHHTTP.post('api/v2/auth/login', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  }

  doRefresh(token) {
    let data = new URLSearchParams();
    data.append('refresh_token', token.refresh_token);
    data.append('grant_type', 'refresh_token');
    data.append('client_id', this.clientId);
    data.append('client_secret', this.clientSecret);

    let post = AUTHHTTP.post('api/v2/auth/refresh', data);
    post.then((response) => {
      saveToken(response.data);
    }).catch((error) => {
      Promise.reject(error);
      removeToken();
      router.push({name: 'Login'});
    });
    return post;
  }
}

/**
 *
 * @type {AuthService}
 */
export const authService = new AuthService();
